import moment from "moment";

export function parseDay(value?: string | null) {
    if (!value) {
        return null;
    }
    const date = moment(value);
    return date.isValid() ? date.startOf("day") : null;
}

function diffDays(from: moment.Moment, to: moment.Moment) {
    return to.diff(from, "days");
}

export function resolveDeliveryDate(row) {
    if (row.deliveryDate) {
        return row.deliveryDate;
    }
    const firstOrder = parseDay(row.orderPlacementTime);
    if (!firstOrder || row.deliveryDays === undefined || row.deliveryDays === null) {
        return "";
    }
    return firstOrder.clone().add(row.deliveryDays, "day").format("YYYY-MM-DD");
}

export function isCompletedStatus(status?: string) {
    return status === "COMPLETED" || status === "已完成";
}

export function calcOverdueDays(row, today = moment().startOf("day")) {
    const deliveryDay = parseDay(resolveDeliveryDate(row));
    if (!deliveryDay) {
        return "-";
    }
    const compareDay = isCompletedStatus(row.status)
        ? parseDay(row.shipmentCompletedDate) || today
        : today;
    if (!compareDay) {
        return "";
    }
    const overdue = diffDays(deliveryDay, compareDay);
    return overdue > 0 ? overdue : "";
}

export function calcRemainingDays(row, today = moment().startOf("day")) {
    if (isCompletedStatus(row.status)) {
        return "";
    }
    const deliveryDay = parseDay(resolveDeliveryDate(row));
    if (!deliveryDay) {
        return "-";
    }
    const remaining = diffDays(today, deliveryDay);
    if (remaining < 0) {
        return "无";
    }
    return remaining;
}

export function isRemainingWarning(value: string | number) {
    return typeof value === "number" && value <= 10;
}

export function formatDate(value?: string) {
    if (!value) {
        return "";
    }
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD") : value;
}

export function getTodayStr() {
    const d = new Date()
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0') // 月份 0 起始需 +1
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
}
